import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useWarehouse } from "../hooks";
import { StockUnitsList } from "../../stock-units/components";

type IWarehouseParams = {
  id: string;
};

export const Warehouse: React.FC = () => {
  const { id } = useParams<IWarehouseParams>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, loading } = useWarehouse(+id!);

  if (loading) return <Loading />;

  const warehouse = data?.warehouse?.result;

  return (
    <>
      <Header
        title="Entrepôt"
        subtitle={warehouse?.name}
        buttons={[
          {
            actionText: "Transférer stock",
            bgColor: "green",
            textColor: "white",
            link: `/warehouse/${id}/transfer`,
          },
          {
            actionText: "Modifier",
            bgColor: "indigo",
            textColor: "white",
            link: `/warehouse/${id}/update`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="section">
          <div className="element">
            <div className="card">
              <CardHeader title="Informations générales" />
              <div className="w-full mt-3">
                <p className="label">Nom</p>
                <input className="input w-full" value={warehouse?.name} disabled />
              </div>
              <div className="w-full mt-3">
                <p className="label">Adresse</p>
                <input className="input w-full" value={warehouse?.address} disabled />
              </div>
              <div className="w-full mt-3">
                <p className="label">Actif</p>
                <input
                  className="input w-full"
                  value={warehouse?.active ? "Oui" : "Non"}
                  disabled
                />
              </div>
            </div>
          </div>

          <div className="element">
            <div className="card">
              <CardHeader title="Lots en stock" />
              <StockUnitsList warehouseId={+id!} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
